export const tnc = {
  url: '/terms-policies/',
  text: 'Terms & Conditions'
};
export const financialService = {
  url: '/terms-policies/',
  text: 'Financial Services Guide'
};
export const privacyPolicy = {
  url: '/terms-policies/privacy-notice/',
  text: 'Privacy Policy'
};
export const productDisclosure = {
  url: '/terms-policies/',
  text: 'Product Disclosure Statement'
};
export const complaintProcedure = {
  url: '/terms-policies/',
  text: 'Complaint Procedure'
};
